import React from 'react'

import InputUser from "./../input/InputUser";
import { axios } from "axios";

const Profile = () => {
  return (
    <div>
      <InputUser/>
    </div>
  )
}

export default Profile

